module.exports = __webpack_public_path__ + "static/img/app.b8e4d83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app.png
// module id = aTzD
// module chunks = 0